import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-relatorio-dialog',
  templateUrl: './relatorio-dialog.component.html'
})
export class RelatorioEmailDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RelatorioEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  fechar(): void {
    this.dialogRef.close();
  }
}